// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qb-6";
export var imgContainer = "_qb-3";
export var menuIcon = "_qb-5";
export var pillWrapper = "_qb-2";
export var pillsContainer = "_qb-1";
export var subscriptionCard = "_qb-0";
export var subscriptionLogo = "_qb-4";